"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaDTO = void 0;
const index_js_1 = require("../../../schema/index.js");
const index_js_2 = require("./getAttrDTO/index.js");
class SchemaDTO extends index_js_1.SchemaAction {
    constructor(schema) {
        super(schema);
        this.type = 'schema';
        this.attributes = Object.fromEntries(Object.entries(this.schema.attributes).map(([attributeName, attribute]) => [
            attributeName,
            (0, index_js_2.getAttrDTO)(attribute)
        ]));
    }
    toJSON() {
        return {
            type: this.type,
            attributes: this.attributes
        };
    }
}
exports.SchemaDTO = SchemaDTO;
SchemaDTO.actionName = 'dto';
